import { MonitorConfig } from '@/models/group'

export const dataGroup = {
  id: '1',
  name: 'Group 1',
  description: 'description 1',
  artifactsBucketName: 'artifactsBucketName 1',
  apiLambdaSrcKey: 'apiLambdaSrcKey 1',
  apiLambdaVersion: 'apiLambdaVersion 1',
  stores: [
    {
      id: '1',
      name: 'Store 1',
      description: 'description 1',
      artifactsBucketName: 'artifactsBucketName 1',
      apiLambdaSrcKey: 'apiLambdaSrcKey 1',
      apiLambdaVersion: 'apiLambdaVersion 1',
      group: 'Groups 1',
    },
    {
      id: '2',
      name: 'Store 2',
      description: 'description 2',
      artifactsBucketName: 'artifactsBucketName 2',
      apiLambdaSrcKey: 'apiLambdaSrcKey 2',
      apiLambdaVersion: 'apiLambdaVersion 2',
      group: 'Groups 2',
    },
    {
      id: '3',
      name: 'Store 3',
      description: 'description 3',
      artifactsBucketName: 'artifactsBucketName 3',
      apiLambdaSrcKey: 'apiLambdaSrcKey 3',
      apiLambdaVersion: 'apiLambdaVersion 3',
      group: 'Groups 3',
    },
    {
      id: '4',
      name: 'Store 4',
      description: 'description 4',
      artifactsBucketName: 'artifactsBucketName 4',
      apiLambdaSrcKey: 'apiLambdaSrcKey 4',
      apiLambdaVersion: 'apiLambdaVersion 4',
      group: 'Groups 4',
    },
    {
      id: '5',
      name: 'Store 5',
      description: 'description 5',
      artifactsBucketName: 'artifactsBucketName 5',
      apiLambdaSrcKey: 'apiLambdaSrcKey 5',
      apiLambdaVersion: 'apiLambdaVersion 5',
      group: 'Groups 5',
    },
  ],
}

export const monitorConfigDefinitionItems = [
  { name: 'enabled', action: 'Add monitoring to the Cloudwatch dashboard', value: 'Boolean' },
  {
    name: 'minInvocationsCount',
    action: 'Lambda min invocations count',
    value: 'Number',
  },
  { name: 'maxFaultCount', action: 'Lambda max fault count', value: 'Number' },
  {
    name: 'maxLatencyMilliseconds',
    action: 'Lambda max latency milisenconds',
    value: 'Number',
  },
  { name: 'maxErrorCount', action: 'DynamoDB max error count', value: 'Number' },
  {
    name: 'writeThrottledEventsCount',
    action: 'DynamoDB write throttled events count',
    value: 'Number',
  },
]

export const monitorConfigExample: MonitorConfig = {
  lambdas: {
    graphql: {
      enabled: true,
      minInvocationsCount: 0,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
    webhook: {
      enabled: true,
      minInvocationsCount: 0,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
    pubsubNotification: {
      enabled: true,
      minInvocationsCount: 0,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
    pubsubOrder: {
      enabled: true,
      minInvocationsCount: 0,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
    pubsubApp: {
      enabled: true,
      minInvocationsCount: 0,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
  },
  apis: {
    graphql: {
      enabled: true,
      max5xxErrorRate: 1,
      max4xxErrorRate: 2,
      maxP90LatencyMillisecond: 300,
      maxTps: 5,
    },
    webhook: {
      enabled: true,
      max5xxErrorRate: 1,
      max4xxErrorRate: 2,
      maxP90LatencyMillisecond: 300,
      maxTps: 5,
    },
  },
  sqs: {
    pubsubNotification: {
      enabled: true,
      maxIncomingMessagesCount: 100,
      maxAgeSeconds: 100,
      maxSizeBytes: 1000000,
      maxTimeToDrainSeconds: 5,
    },
    pubsubOrder: {
      enabled: true,
      maxIncomingMessagesCount: 100,
      maxAgeSeconds: 100,
      maxSizeBytes: 1000000,
      maxTimeToDrainSeconds: 5,
    },
    pubsubApp: {
      enabled: true,
      maxIncomingMessagesCount: 100,
      maxAgeSeconds: 100,
      maxSizeBytes: 1000000,
      maxTimeToDrainSeconds: 5,
    },
  },
  sns: {
    group: {
      enabled: true,
      maxNotificationsFailedCount: 1,
    },
  },
}
